import React, { useState, createRef, useEffect, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Label,
  Input,
  Button,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Spinner,
  Alert,
  CustomInput,
  Tooltip
} from 'reactstrap';
import myma_logo from './../../assets/myma_logo.png';
import { NavLink } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { postAPI_Onboard, postAPI_EmailCheck } from '../../constants/APIs';
import { Colxx } from '../../components/common/CustomBootstrap';
import { Wizard, Steps, Step } from 'react-albus';
import BottomNavigation from '../../components/wizard/BottomNavigation';
import TopNavigation from '../../components/wizard/TopNavigation';
import { Formik, Form, Field } from 'formik';
import Select from 'react-select';
import country from '../../data/country';
import timeZoneList from '../../data/timeZoneList';
import currencyList from '../../data/currencyList';
import { reactSelectOptionDiffrentPro } from '../../helpers/Utils';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import queryString from 'query-string'
import {
  gAPI_Products_List,
  gAPI_Stripe_PromoCode,
} from '../../constants/APIs';
import PasswordStrengthBar from 'react-password-strength-bar';
import ProductListItem from './components/ProductListItem';
import ProductListItemCompact from './components/ProductListItemCompact';
import GeniusPlan from './components/GeniusPlan';
import billingCurrencyList from '../../data/billingCurrencyList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

function SignUp() {
  const [tooltip, setToolTip] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [propertyNameToolTip, setPropertyNameToolTip] = useState(false);
  const [nameToolTip, setNameToolTip] = useState(false);
  const [emailToolTip, setEmailToolTip] = useState(false);
  const [selectZones, setSelectZones] = useState();
  const [productsList, setProductsList] = useState([]);
  const forms = [createRef(null), createRef(null), createRef(null)];
  const [bottomNavHidden, setBottomNavHidden] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productVisible, setProductVisible] = useState(false);
  const [terms, setTerms] = useState(false);
  const [widthDiv, setwidthDiv] = useState('95%');
  const [isShow, setIsShow] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  const [propertyData, setpropertyData] = useState({
    name: '',
    website: '',
    type: 'Hotel',
    country: '',
    timeZone: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    currency: '',
    stripeProductId: '',
    stripePriceId: '',
    productId: 0,
    priceId: 0,
    billingCurrency: '',
    promoId: '',
    promoCode: '',
    data: '',
    invitationType: '',
    images: '',
    isBmb: true,
    isAiva: false,
  });

  const togglePropertyNameToolTip = () => {
    setPropertyNameToolTip(!propertyNameToolTip);
  };
  const toggleNameToolTip = () => {
    setNameToolTip(!nameToolTip);
  };
  const toggleEmailToolTip = () => {
    setEmailToolTip(!emailToolTip);
  };
  const toggle = () => {
    setProductVisible(!productVisible);
  };
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const LoadData = (currency) => {
    AxiosPublicAPI({
      methhod: 'get',
      url: `${gAPI_Products_List}?currency=${currency}&type=Website`,
    })
      .then((res) => {
        setProductsList(res.data);
        const params = new URLSearchParams(window.location.search);
        let product = params.get('product');

        if (product === null) {
          if (res.data.length >= 2) {
            let product = res.data[1];
            setpropertyData({
              ...propertyData,
              stripeProductId: product.productStripeId,
              stripePriceId: product.priceStripeId,
              productId: product.productId,
              priceId: product.pricingId,
            });
            setFormErrors({
              ...formErrors,
              productId: '',
            });
          }
        } else {
          let productArr = res.data.filter(
            (item) => item.productStripeId === product
          );
          if (productArr.length > 0) {
            setpropertyData({
              ...propertyData,
              stripeProductId: productArr[0].productStripeId,
              stripePriceId: productArr[0].priceStripeId,
              productId: productArr[0].productId,
              priceId: productArr[0].pricingId,
            });
            setFormErrors({
              ...formErrors,
              productId: '',
            });
          }
        }

        console.log(res.data);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));
  };
  const handleCheckChange = (e) => {
    setTerms(e.target.checked);
  };
  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
    setFormErrors({
      ...formErrors,
      [e.target.name]: '',
    });
  };

  const asyncLoading = () => {
    setLoading(true);
    // setTimeout(() => {
    //     setLoading(false);
    // }, 3000);
  };

  async function CheckEmail(email) {
    let isValid = true;
    await AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_EmailCheck}`,
      data: {
        email: propertyData.email,
      },
    })
      .then((res) => {
        console.log(res.data);
        if (res.data.exists === true) {
          isValid = false;
          //errors.email = 'Email already registered with us.'
        }
      })
      .catch((err) => console.log('err', err));
    return isValid;
  }
  const onClickNext = (goToNext, steps, step) => {
    if (steps.length - 1 <= steps.indexOf(step)) {
      return;
    }
    const formIndex = steps.indexOf(step);
    const form = forms[formIndex].current;
    console.log(formIndex);
    setFormErrors({});
    form.submitForm().then(async () => {
      let isValid = true;
      let errors = {};
      // // console.log(propertyData)
      if (formIndex == 0) {
        var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
        if (propertyData.name === '') {
          isValid = false;
          errors.name = 'Please enter property name';
        }
        if (propertyData.website === '') {
          isValid = false;
          errors.website = 'Please enter property website';
        }
        if (propertyData.country === '') {
          isValid = false;
          errors.country = 'Please select country';
        }
      }
      if (formIndex == 1) {
        if (propertyData.firstName === '') {
          isValid = false;
          errors.firstName = 'Please enter first name';
        }
        if (propertyData.lastName === '') {
          isValid = false;
          errors.lastName = 'Please enter last name';
        }
        if (propertyData.email === '') {
          isValid = false;
          errors.email = 'Please enter email';
        }
        if (propertyData.phoneNumber === '') {
          isValid = false;
          errors.phoneNumber = 'Please enter phone number';
        }
        if (propertyData.password === '') {
          isValid = false;
          errors.password = 'Please enter password';
        } else {
          var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
          if (propertyData.password.length >= 12 && propertyData.password.length <= 16 &&
            /(?=.*[A-Z])/.test(propertyData.password) && /(?=.*[a-z])/.test(propertyData.password) &&
            /(?=.*[0-9])/.test(propertyData.password) && /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(propertyData.password)) {
            isValid = true;
          } else {
            isValid = false;
            setIsShow(true);
          }
        }
        if (propertyData.confirmPassword === '') {
          isValid = false;
          errors.confirmPassword = 'Please enter confirm password';
        } else if (propertyData.password !== propertyData.confirmPassword) {
          isValid = false;
          errors.confirmPassword = 'Password and confirm password should match';
        }

        if (propertyData.email !== '') {
          if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
              propertyData.email
            )
          ) {
            errors.email = 'Invalid email address';
          } else {
            if ((await CheckEmail(propertyData.email)) === false) {
              isValid = false;
              errors.email = 'Email already registered with us.';
            }
          }
        }
      }
      let couponId = '';
      if (formIndex == 2) {
        if (propertyData.stripeProductId === '') {
          isValid = false;
          errors.productId = 'Please subscribe to any 1 package';
        }
        if (terms === false) {
          isValid = false;
          errors.terms = 'Please accept the terms and conditions first.';
        }
        if (propertyData.promoCode !== '') {
          await AxiosPublicAPI({
            methhod: 'get',
            url: `${gAPI_Stripe_PromoCode}?code=${propertyData.promoCode}`,
          }).then((res) => {
            if (res.data.promoCodes.length > 0) {
              couponId = res.data.promoCodes[0].coupon.id;
            } else {
              isValid = false;
              errors.promo = 'Promo code is invalid/expired. Please try again.';
            }
          });
        }
      }
      console.log(isValid);
      setFormErrors(errors);

      if (isValid) {
        if (formIndex === 0) {
          LoadData(propertyData.currency);
          setwidthDiv('95%');
        } else if (formIndex === 1) {
          setwidthDiv('100%');
        }
        goToNext();
        step.isDone = true;
        if (steps.length - 2 <= steps.indexOf(step)) {
          setBottomNavHidden(true);
          asyncLoading();
          if (formIndex == 2) {
            propertyData.promoId = couponId;
            try {
              let values = window.location.href.substring(window.location.href.lastIndexOf("=") + 1
                , window.location.href.length);
              if (values !== '') {
                propertyData.data = values;
                propertyData.invitationType = 'SignUp';
                localStorage.removeItem('Invitation');
              }
            } catch { }
            //if (propertyData.password.length >= 12 && propertyData.length <= 16) {
            AxiosPublicAPI({
              method: 'post',
              url: `${postAPI_Onboard}`,
              data: propertyData,
            })
              .then((res) => {
                if (res.data.invitationId !== undefined) {
                  localStorage.removeItem('Invitation');
                  localStorage.setItem("Invitation", res.data.invitationId);
                }
                setLoading(false);
              })
              .catch((err) => console.log('err', err));

          }
        }

      }
    });
  };

  const onClickPrev = (goToPrev, steps, step) => {
    setwidthDiv('95%');
    if (steps.indexOf(step) <= 0) {
      return;
    }
    goToPrev();
  };
  const SelectedProduct = (
    e,
    stripeProductId,
    stripePriceId,
    productId,
    priceId
  ) => {
    if (e.target.tagName !== 'A') {
      setpropertyData({
        ...propertyData,
        stripeProductId: stripeProductId,
        stripePriceId: stripePriceId,
        productId: productId,
        priceId: priceId,
      });
      setFormErrors({
        ...formErrors,
        productId: '',
      });
    }
  };

  const handleChangeSelect = (value, { name }) => {
    setFormErrors({
      ...formErrors,
      country: '',
    });
    let timeZone = '';
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    if (timeZones.length > 0) {
      if (timeZones[0].TimeZones.length === 1) {
        timeZone = timeZones[0].TimeZones[0];
        setSelectZones(
          timeZones[0].TimeZones.map((zone) => {
            return <option value={zone}>{zone}</option>;
          })
        );
      } else {
        timeZone = timeZones[0].TimeZones[0];
        setSelectZones(
          timeZones[0].TimeZones.map((zone) => {
            return <option value={zone}>{zone}</option>;
          })
        );
      }
    }

    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    if (currency.length > 0) {
      let billingCurrencyarr = billingCurrencyList.filter(
        (item) => item.countryCode === value.value
      );
      setpropertyData({
        ...propertyData,
        country: value.value,
        timeZone: timeZone,
        currency: currency[0].currencyCode,
        billingCurrency: billingCurrencyarr[0].currencyCode,
      });
    }
  };

  return (
    <Fragment>
      <Row className="h-100">
        <Colxx xxs="12" md="12" className="mx-auto my-auto">
          <Card className="auth-card">
            {/* <div className="position-relative image-side ">
                        <p className="text-white h2">Join many other smart accommodation providers converting seamless conversions into direct bookings</p>
                        <p className="white mb-0">
                            Please use this form to register.
              </p>

                        <ul id='ulRegister' className="white mb-0 mt-5">
                            <li>Boost Sales</li>
                            <li>Provide a 5-Star Guest Experience</li>
                            <li>Save Costs</li>
                        </ul>

                    </div> */}
            <div
              className="form-side wizard wizard-default "
              style={{ padding: '20px', margin: 'auto', width: widthDiv }}
            >
              <div style={{ textAlign: 'center' }}>
                <NavLink to={`/`} className="white">
                  <span className="logo-single" style={{ marginBottom: '0px' }}>
                    {' '}
                    <img
                      src={myma_logo}
                      width="150"
                      height="100"
                    />{' '}
                  </span>
                </NavLink>
                <CardTitle>
                  Try Chatbot on your Website & Facebook page for free
                </CardTitle>
                <p>
                  Sign up and you will get an email within 24 hrs with your
                  account information
                </p>
              </div>
              <Wizard>
                <TopNavigation className="justify-content-center" disableNav />
                <Steps>
                  <Step id="step1" name="Step 1" desc="Property Details">
                    <div className="wizard-basic-step">
                      <Formik
                        innerRef={forms[0]}
                        initialValues={{}}
                        onSubmit={() => { }}
                      >
                        {({ errors, touched }) => (
                          <Form className="av-tooltip tooltip-label-right rounded">
                            <FormGroup>
                              <Label>
                                Property Name{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="propertyNametip"
                                ></i>
                              </Label>
                              <Field
                                className="form-control"
                                name="name"
                                value={propertyData.name}
                                onChange={handleChange}
                              />
                              {formErrors.name && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.name}
                                </div>
                              )}
                              <Tooltip
                                placement="right"
                                isOpen={propertyNameToolTip}
                                target="propertyNametip"
                                toggle={togglePropertyNameToolTip}
                              >
                                If you are group, setup one property, you will be
                                able to add more later on.
                              </Tooltip>
                            </FormGroup>
                            <FormGroup>
                              <Label>Property Website </Label>
                              <Field
                                className="form-control"
                                name="website"
                                value={propertyData.website}
                                onChange={handleChange}
                              />

                              {formErrors.website && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.website}
                                </div>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label>Property Type</Label>
                              <Input
                                type="select"
                                value={propertyData.type}
                                name="type"
                                onChange={handleChange}
                              >
                                <option value="CampGround">Camping Ground</option>
                                <option value="Bach">Holiday Home/Bach</option>
                                <option value="Hostel">Hostel</option>
                                <option value="Hotel">Hotel</option>
                                <option value="Motel">Motel or Lodge</option>
                                <option value="Pub">Pub</option>
                                <option value="Resort">Resort</option>
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <Label>Country</Label>
                              <Select
                                isMulti={false}
                                className="react-select"
                                classNamePrefix="react-select"
                                name="code"
                                placeholder="Select Country"
                                onChange={handleChangeSelect}
                                options={
                                  country
                                    ? reactSelectOptionDiffrentPro(
                                      country,
                                      true,
                                      'code',
                                      'name',
                                      ''
                                    )
                                    : []
                                }
                              />
                              {formErrors.country && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.country}
                                </div>
                              )}
                            </FormGroup>
                            {selectZones !== undefined && selectZones.length > 1 && (
                              <FormGroup>
                                <Label>Time Zone</Label>
                                <Input
                                  name="timeZone"
                                  type="select"
                                  onChange={handleChange}
                                  value={propertyData.timeZone}
                                >
                                  {selectZones}
                                </Input>
                              </FormGroup>
                            )}
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Step>
                  <Step id="step2" name="Step 2" desc="User Details">
                    <div className="wizard-basic-step">
                      <Formik
                        innerRef={forms[1]}
                        initialValues={{}}
                        onSubmit={() => { }}
                      >
                        {({ errors, touched }) => (
                          <Form className="av-tooltip tooltip-label-right rounded">
                            <FormGroup>
                              <Label>
                                First Name{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="nametip"
                                ></i>
                              </Label>
                              <Field
                                className="form-control"
                                name="firstName"
                                value={propertyData.firstName}
                                onChange={handleChange}
                              />
                              {formErrors.firstName && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.firstName}
                                </div>
                              )}
                              <Tooltip
                                placement="right"
                                isOpen={nameToolTip}
                                target="nametip"
                                toggle={toggleNameToolTip}
                              >
                                This is your first user account, and you will be
                                able to add your team members later on.
                              </Tooltip>
                            </FormGroup>
                            <FormGroup>
                              <Label>Last Name</Label>
                              <Field
                                className="form-control"
                                name="lastName"
                                value={propertyData.lastName}
                                onChange={handleChange}
                              />
                              {formErrors.lastName && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.lastName}
                                </div>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label>
                                Business Email{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="emailtip"
                                ></i>
                              </Label>
                              <Field
                                className="form-control"
                                name="email"
                                value={propertyData.email}
                                onChange={handleChange}
                              />
                              {formErrors.email && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.email}
                                </div>
                              )}
                              <Tooltip
                                placement="right"
                                isOpen={emailToolTip}
                                target="emailtip"
                                toggle={toggleEmailToolTip}
                              >
                                Your first account will be created with this email
                                address.
                              </Tooltip>
                            </FormGroup>
                            <FormGroup>
                              <Label>Phone Number</Label>
                              <Field
                                className="form-control"
                                name="phoneNumber"
                                value={propertyData.phoneNumber}
                                onChange={handleChange}
                              />
                              {formErrors.phoneNumber && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.phoneNumber}
                                </div>
                              )}
                            </FormGroup>
                            <div className='m-2'>
                              <h6>Your password must contain </h6>
                              <ul className='ml-3'>
                                <li className='mb-2'>Atleast 12 Characters.</li>
                                <li className='mb-2'>Atleast one upper case letter.</li>
                                <li className='mb-2'>Atleast one lower case letter.</li>
                                <li className='mb-2'>Atleast one number.</li>
                                <li className='mb-2'>Atleast one of the following symbols (?=.*[@#$%^&-+=()]).</li>
                              </ul>
                            </div>
                            <FormGroup>
                              <Label>Password</Label>
                              <Field
                                id="Tooltip"
                                className="form-control"
                                type={isPasswordVisible ? 'text' : 'password'}
                                name="password"
                                value={propertyData.password}
                                onChange={handleChange}
                              />
                              <FontAwesomeIcon
                                icon={isPasswordVisible ? faEyeSlash : faEye}
                                onClick={togglePasswordVisibility}
                                style={{
                                  cursor: 'pointer',
                                  position: 'absolute',
                                  right: '10px',
                                  top: '38px',
                                }}
                              />
                              <Tooltip
                                placement={'right'}
                                isOpen={tooltip}
                                target={"Tooltip"}
                                toggle={() => setToolTip(!tooltip)}
                              >
                                <p className='text-start' style={{ color: `${(propertyData.password.length >= 12) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast 12 characters</span></p>
                                <p className='text-start' style={{ color: `${/(?=.*[A-Z])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one upper case character</span></p>
                                <p className='text-start' style={{ color: `${/(?=.*[a-z])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one lower case character</span></p>
                                <p className='text-start' style={{ color: `${/(?=.*[0-9])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one number</span></p>
                                <p className='text-start' style={{ color: `${/(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one special character</span></p>
                              </Tooltip>

                              {
                                formErrors.password && (
                                  <div className="invalid-feedback d-block">
                                    {formErrors.password}
                                  </div>
                                )
                              }
                            </FormGroup>

                            {propertyData.password !== '' && <div className=""><PasswordStrengthBar minLength={12}
                              password={propertyData.password}></PasswordStrengthBar>
                            </div>}
                            <FormGroup>
                              <Label>Confirm Password</Label>
                              <Field
                                id="confirmPassword"
                                className="form-control"
                                type={isConfirmPasswordVisible ? 'text' : 'password'}
                                name="confirmPassword"
                                value={propertyData.confirmPassword}
                                onChange={handleChange}
                              />
                              <FontAwesomeIcon
                                icon={isConfirmPasswordVisible ? faEyeSlash : faEye}
                                onClick={toggleConfirmPasswordVisibility}
                                style={{
                                  cursor: 'pointer',
                                  position: 'absolute',
                                  right: '10px',
                                  top: '38px',
                                }}
                              />
                              {formErrors.confirmPassword && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.confirmPassword}
                                </div>
                              )}
                            </FormGroup>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Step>
                  <Step id="step3" name="Step 3" desc="Subscription">
                    <div className="wizard-basic-step">
                      <Formik
                        innerRef={forms[2]}
                        initialValues={{}}
                        onSubmit={() => { }}
                      >
                        {({ errors, touched }) => (
                          <Form className="av-tooltip tooltip-label-right rounded">
                            <div className="equal-height-container row">
                              {!loading ? (
                                productsList.map((item, index) => {
                                  return (
                                    <ProductListItemCompact
                                      key={`product_item_${index}`}
                                      item={item}
                                      toggle={toggle}
                                      SelectedProduct={SelectedProduct}
                                      SelectedProductID={
                                        propertyData.stripeProductId
                                      }
                                      w={3}
                                      voucher={false}
                                    />
                                  );
                                })
                              ) : (
                                <div className="loading" />
                              )}

                              <GeniusPlan
                                toggle={toggle}
                                SelectedProduct={SelectedProduct}
                                SelectedProductID={propertyData.stripeProductId}
                              />
                            </div>
                            {formErrors.productId && (
                              <Alert color="danger" className="rounded">
                                {formErrors.productId}
                              </Alert>
                            )}
                            {formErrors.terms && (
                              <Alert color="danger" className="rounded">
                                {formErrors.terms}
                              </Alert>
                            )}
                            {formErrors.promo && (
                              <Alert color="danger" className="rounded">
                                {formErrors.promo}
                              </Alert>
                            )}
                            <div style={{ textAlign: 'center' }}>
                              <CustomInput
                                type="checkbox"
                                id="chkTerms"
                                checked={terms}
                                onChange={handleCheckChange}
                                name="terms"
                                label={
                                  <label>
                                    I agree to the{' '}
                                    <a
                                      rel="noopener noreferrer"
                                      target="_blank"
                                      href="https://www.bookmebob.com/terms"
                                      style={{ textDecoration: 'underline' }}
                                    >
                                      Terms and Conditions
                                    </a>
                                  </label>
                                }
                              />
                            </div>
                            <div className="row text-center mb-3">
                              <div class="col-xs-4"></div>
                              <div class="col-xs-4">
                                {' '}
                                <Field
                                  className="form-control"
                                  type="text"
                                  name="promoCode"
                                  value={propertyData.promoCode}
                                  placeholder="Enter Promo Code"
                                  onChange={handleChange}
                                  width="150px"
                                />
                              </div>
                              <div class="col-xs-4"></div>
                            </div>
                            <Fragment>
                              <Modal
                                isOpen={productVisible}
                                toggle={toggle}
                                size="lg"
                                style={{ maxWidth: '1024px' }}
                              >
                                <ModalHeader toggle={toggle}>
                                  Packages
                                </ModalHeader>
                                <ModalBody>
                                  <div className="equal-height-container mb-5 row">
                                    {!loading ? (
                                      productsList.map((item, index) => {
                                        return (
                                          <ProductListItem
                                            key={`product_item_${index}`}
                                            item={item}
                                            SelectedProduct={SelectedProduct}
                                            SelectedProductID={
                                              propertyData.stripeProductId
                                            }
                                            w={4}
                                            voucher={false}
                                          />
                                        );
                                      })
                                    ) : (
                                      <div className="loading" />
                                    )}
                                  </div>
                                </ModalBody>
                                <ModalFooter>
                                  <Button color="secondary" onClick={toggle}>
                                    Close
                                  </Button>
                                </ModalFooter>
                              </Modal>
                            </Fragment>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Step>
                  <Step id="step4" hideTopNav>
                    <div className="wizard-basic-step text-center pt-3">
                      {loading ? (
                        <div>
                          <Spinner color="primary" className="mb-1" />
                          <p>Your request is in progress</p>
                        </div>
                      ) : (
                        <div>
                          <h2 className="mb-2">Thank You!</h2>
                          <p>
                            Your registration completed successfully!. Once
                            verified, you will get notified via email.
                          </p>
                        </div>
                      )}
                    </div>
                  </Step>
                </Steps>
                <BottomNavigation
                  onClickNext={onClickNext}
                  onClickPrev={onClickPrev}
                  className={`justify-content-center ${bottomNavHidden && 'invisible'
                    }`}
                  prevLabel="Back"
                  nextLabel="Next"
                />
              </Wizard>
            </div>
          </Card>
        </Colxx>
      </Row>
      <Modal isOpen={isShow} toggle={() => setIsShow(!isShow)}>
        <ModalHeader toggle={() => setIsShow(!isShow)}>
          Password
        </ModalHeader>
        <ModalBody>
          <h6 className="m-2">  Password length must be in between of 12 to 16 character and its must have atleast 1 upper case,
            1 lower case, 1 digit and 1 special character.</h6>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setIsShow(!isShow)}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

export default injectIntl(SignUp);

